/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ArbitratorEvaluationExportSourceSchema } from './arbitratorEvaluationExportSourceSchema';
import type { ArbitratorSessionExportSourceSchema } from './arbitratorSessionExportSourceSchema';
import type { PipelineExportSourceSchema } from './pipelineExportSourceSchema';
import type { SearchExportSourceSchema } from './searchExportSourceSchema';
import type { SearchInsightsExportSourceSchema } from './searchInsightsExportSourceSchema';

/**
 * Pre-flight cost calculation for an export selection. Same source union
 * as `StartExportRequestSchema`; resolves and authorizes identically but
 * writes nothing.
 */
export interface ExportEstimateRequestSchema {
  source: SearchExportSourceSchema | PipelineExportSourceSchema | ArbitratorSessionExportSourceSchema | ArbitratorEvaluationExportSourceSchema | SearchInsightsExportSourceSchema;
}
